import React from 'react'
import MobProfileWrapper from './components/MobProfileWrapper'

const PatProfile = () => {
  return <MobProfileWrapper />
}

export default PatProfile
